import "./index.css";

function StandOutText() {

  return (
        <div className="big-text explainer">An agent that <span className="highlight-green">reads the internet</span> for you, surfaces what matters, and helps you respond with an <span className="highlight-green">authentic, knowledgeable voice</span> - so you lead the conversation instead of chasing it.</div>
  );
}

export default StandOutText;